
export const decimalFormatter = (value:number, rounding = 2) => {

    if (isNaN(value)) {
        console.warn('Item is not a number and cannot be formatted.', { value });
        return value;
    }
    return RoundDecimal(value, rounding);
}


const RoundDecimal = (num:number, rounding:number) => {
    let roundedNumber = (Number(num)).toFixed(rounding);
    return roundedNumber;
}